import React from 'react';
import gql from 'graphql-tag';
import {compose} from 'redux';
import {Query} from 'react-apollo';
import {connect} from 'react-redux';
import ErrorInviteModal from './error-invite-modal';
import AcceptInviteModal from './accept-invite-modal';
import {ROLES} from '../../../utils/constants.js';
import {withTranslationsAsProps} from '../../../components/translations';
import {withAuth} from '../../../components/auth';
import collaborateActions from '../actions';
import {BOARD_ERROR_CODES} from '../../../../server/plugins/tripboard-invitations/constants';

const query = gql`
    query invitationPreview($hav: String!, $invitationId: String!, $listingPageSize: Int!) {
        invitationPreview(hav: $hav, invitationId: $invitationId) {
            unitsCount
            code
            tripBoardUuid
            tripBoardName
            stay {
                dateRange {
                    arrival
                    departure
                }
            }
            tripBoard {
                listings(pageSize: $listingPageSize) {
                    mobileThumbnailUrl
                }
                users {
                    isMe
                    role {
                        type
                    }
                }
            }
        }
    }
`;

const defaultNumberOfListings = 3;
export const InviteModalProvider = (ownProps) => (
    <Query
        query={query}
        errorPolicy={'all'}
        skip={!ownProps.hav || !ownProps.invitationId}
        variables={{
            hav: ownProps.hav,
            invitationId: ownProps.invitationId,
            listingPageSize: ownProps.numListingsInPreview || defaultNumberOfListings
        }}
    >
        {({data, error, loading}) => {
            if (loading) {
                return null;
            }
            const {tripBoardUuid: boardId, unitsCount, tripBoardName, stay, tripBoard, code} =
                data && data.invitationPreview;
            const {
                invitationId,
                noPropertiesText,
                propertiesText,
                expiredTitleText,
                expiredBodyText,
                expiredCTAText,
                isLoggedIn
            } = ownProps;
            let isMe = false;
            let myRole = ROLES.VIEWER;
            const users = (tripBoard && tripBoard.users) || [];
            users.filter((user) => user).forEach((user) => {
                if (user.isMe) {
                    isMe = true;
                    myRole = (user.role && user.role.type) || ROLES.VIEWER;
                }
            });
            const byPass = isMe && isLoggedIn && myRole !== ROLES.VIEWER;
            if (!byPass && (error || BOARD_ERROR_CODES.includes(code))) {
                return (
                    <ErrorInviteModal
                        {...{
                            invitationId,
                            titleText: expiredTitleText,
                            bodyText: expiredBodyText,
                            skipText: expiredCTAText,
                            noPropertiesText,
                            propertiesText,
                            boardId,
                            unitsCount,
                            tripBoardName,
                            stay,
                            tripBoard
                        }}
                    />
                );
            }

            return (
                <AcceptInviteModal {...{...ownProps, boardId, unitsCount, tripBoardName, stay, tripBoard, byPass}} />
            );
        }}
    </Query>
);

const mapDispatchToProps = {
    fetchLogin: collaborateActions.login
};

const mapStateToProps = (state) => {
    const collaborateState =
        (state && state.tripboard && state.tripboard.collaborate && state.tripboard.collaborate.modal) || {};
    const systemState = (state && state.system) || {};
    return {
        loginUrl: collaborateState.loginUrl || '',
        loginFetchError: collaborateState.error,
        loginFetchLoading: collaborateState.loading,
        fullLocale: systemState.fullLocale,
        siteName: systemState.siteName
    };
};

export default compose(
    withTranslationsAsProps({
        'tripboards.modal.invite.add': 'addText',
        'tripboards.modal.invite.loginto': 'loginToText',
        'tripboards.modal.invite.noproperties': 'noPropertiesText',
        'tripboards.modal.invite.properties': 'propertiesText',
        'tripboards.modal.invite.skip': 'skipText',
        'tripboards.modal.invite.title': 'titleText',
        'tripboards.modal.invite.vote': 'voteText',
        'tripboards.modal.invite.accept': 'loginText',
        'tripboards.modal.invite.expired.title': 'expiredTitleText',
        'tripboards.modal.invite.expired.body': 'expiredBodyText',
        'tripboards.modal.invite.expired.cta': 'expiredCTAText',
        'tripboards.invite.signup': 'signupText'
    }),
    connect(mapStateToProps, mapDispatchToProps),
    withAuth
)(InviteModalProvider);



// WEBPACK FOOTER //
// ./src/universal/tripboard/collaborate/components/invite-modal-provider.js